import React, { useRef, useEffect, useState } from 'react';
import 'mapbox-gl/dist/mapbox-gl.css';
import '../styles/map.css';
import mapboxgl from 'mapbox-gl';
import ReactDOM from 'react-dom';
import marker from '../assets/marker.png';
import $ from 'jquery';

// eslint-disable-next-line import/no-webpack-loader-syntax
mapboxgl.workerClass = require('worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker').default;

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN_PUBLIC;

function getContents(feature) {
  let contents = `<h3>${feature.properties.Name}</h3>`
  contents += feature.properties.Date ? `<p><b>Year: </b>${feature.properties.Date}</p>` : ``;
  contents += feature.properties.Client ? `<p><b>Client:</b> ${feature.properties.Client}</p>` : ``;
  contents += feature.properties.City ? `<p><b>City:</b> ${feature.properties.City}</p>` : ``;
  contents += feature.properties.Status ? `<p><b>Status:</b> ${feature.properties.Status}</p>` : ``;
  contents += feature.properties.Typology ? `<p><b>Typology:</b> ${feature.properties.Typology}</p>` : ``;
  contents += feature.properties.Category ? `<p><b>Category:</b> ${feature.properties.Category}</p>` : ``;

  return contents;
}

const Map2 = ( ) => {
  const mapContainerRef = useRef(null);
  const tooltipRef = useRef(new mapboxgl.Popup({ offset: 15 }));

  const [lng, setLng] = useState(-71.1211);
  const [lat, setLat] = useState(42.3938);
  const [zoom, setZoom] = useState(11.59);

  // Initialize map when component mounts
  useEffect(() => {
    const map = new mapboxgl.Map({
      container: mapContainerRef.current,
      style: 'mapbox://styles/rokeby/ckuxv0lk922wk17qgu6r6bota',
      center: [lng, lat],
      zoom: zoom,
    });

  map.on('load', () => {
    map.on('click', (event) => {
      console.log('inner width is', window.innerWidth)

          const features = map.queryRenderedFeatures(event.point, {
            layers: ['tac-foreign-obj'] 
          });
          if (!features.length) {
            return;
          }

          const feature = features[0];
          let contents = getContents(feature)
          $('#infoBox').html(contents)


          //how to layout on mobile
          if(window.innerWidth > 1000){
            contents = getContents(feature)
            const popup = new mapboxgl.Popup({ offset: [0, 0] })
              .setLngLat(feature.geometry.coordinates)
              .setHTML(contents)
              .addTo(map);
          }
        });
    }

  )

    // Clean up on unmount
    return () => map.remove();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div id='container'>
    <div className='mapContainer' ref={mapContainerRef} />
    <div id='infoBox'></div>
    </div>
  );
};

export default Map2;